export default __webpack_public_path__ + "static/media/instructions-sog.4655f2aa.png";